/* ClearSight "Vision Loss" advertorial - vanilla re-implementation of the GemPages runtime behaviours this page uses
 * on top of cs-listicle.js (lazy sections). Sources: assets.gemcommerce.com/assets-v2/gp-icon-list-v7-5.js,
 * gp-sticky-v7-5.js, gp-button-v7-5.js + gp-global.js link handler (all v1767807736903, as loaded by the live page).
 * 1) gp-icon-list: gp-data {position, iconWidth} per device. For every device whose position is not "center" the icon is
 *    top-aligned (--ai flex-start) and nudged down by ceil(lineHeight/2 - iconWidth/2) px (--top, --pos relative), where
 *    lineHeight = the CURRENT computed line-height of the first .gp-icon-list-text; "center" -> --ai center, --pos static.
 *    Appended to the inline styles, recomputed on resize. Runs for ALL icon lists at page load (the component is defined
 *    by the non-lazy first section, so lazy sections' lists are measured before their CSS is switched on - as on live).
 * 2) gp-sticky display "after-first-cart-button": observes the first <gp-product-button> outside a sticky and shows the
 *    sticky (--d block) once that button has scrolled above the viewport. This page has NO gp-product-button, so (as on the
 *    live page) the sticky scroll-to-top button stays --d:none.
 * 3) gp-button link "#scroll-to-top" (target _self): smooth scroll to the top (gp-global.js).
 */
(function () {
  'use strict';
  function state(el) { try { return JSON.parse(el.getAttribute('gp-data')) || {}; } catch (e) { return {}; } }
  function css(o) { var s = ''; if (!o || typeof o !== 'object') return s; Object.keys(o).forEach(function (k) { s += k + ': ' + o[k] + ';'; }); return s; }
  var DEV = ['desktop', 'tablet', 'mobile'], SUF = { desktop: '', tablet: '-tablet', mobile: '-mobile' };
  function pick(o, k) { return o == null ? undefined : o[k]; }
  function compose(lh, pos, iw) {
    var a = {}, c = {};
    if (iw) Object.keys(iw).forEach(function (k) { c[k] = iw[k]; });
    var d = pick(iw, 'desktop'), t = pick(iw, 'tablet'), m = pick(iw, 'mobile');
    c.desktop = d != null ? d : 0;
    c.tablet = t != null ? t : (d != null ? d : 0);
    c.mobile = m != null ? m : (t != null ? t : (d != null ? d : 0));
    DEV.forEach(function (dev) {
      var p = pos && pos[dev], r = c[dev];
      if (!p) return;
      var l = SUF[dev] || '';
      a.wrapper = a.wrapper || {}; a.content = a.content || {};
      if (p === 'center') { a.wrapper['--ai' + l] = 'center'; a.content['--pos' + l] = 'static'; }
      else if (r && lh) {
        var i = parseFloat(String(lh).replace(/[a-zA-Z]/g, '')) / 2 - r / 2;
        a.wrapper['--ai' + l] = 'flex-start';
        a.content['--top' + l] = Math.max(0, Math.ceil(i)) + 'px';
        a.content['--pos' + l] = 'relative';
      }
    });
    return a;
  }
  function iconList(el) {
    if (el.__csInit) return; el.__csInit = true;
    var st = state(el), pos = st.position, iw = st.iconWidth;
    if (!pos && !iw) return;
    var textEl = el.querySelector('.gp-icon-list-text'), lh;
    function apply() {
      var cp = compose(lh, pos, iw);
      el.querySelectorAll('.gp-icon-list-wrapper').forEach(function (w) {
        w.style.cssText += css(cp.wrapper);
        var ic = w.querySelector('.gp-icon-list-icon');
        if (ic) ic.style.cssText += css(cp.content);
      });
    }
    if (iw && textEl) lh = getComputedStyle(textEl).getPropertyValue('line-height');
    apply();
    if (textEl) window.addEventListener('resize', function () {
      if (iw) lh = getComputedStyle(textEl).getPropertyValue('line-height');
      apply();
    });
  }
  function whenLive(el, fn) {
    var lazy = el.closest('.gps-lazy');
    if (!lazy) { fn(el); return; }
    var mo = new MutationObserver(function () {
      if (!lazy.classList.contains('gps-lazy')) { mo.disconnect(); fn(el); }
    });
    mo.observe(lazy, { attributes: true, attributeFilter: ['class'] });
  }
  function sticky(el) {
    var st = state(el), uid = st.uid, box = uid && document.getElementById(uid);
    if (!box || !st.setting) return;
    var disp = st.setting.display || {}, adv = (st.advanced && st.advanced.d) || {};
    function dev() { var w = window.innerWidth; return w < 768 ? 'mobile' : (w < 1025 ? 'tablet' : 'desktop'); }
    var obs = {}, cur = {};
    function run() {
      var d = dev(), suf = d === 'desktop' ? '' : '-' + d;
      if (disp[d] !== 'after-first-cart-button') return;
      var btns = Array.prototype.filter.call(document.querySelectorAll('gp-product-button'), function (b) { return !b.closest('gp-sticky'); });
      if (!btns.length || obs[suf]) return;
      var show = adv[d] != null ? adv[d] : true;
      obs[suf] = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var n = e.isIntersecting ? 'none' : (e.boundingClientRect.top < 0 && show ? 'block' : (cur[suf] || 'none'));
          if (cur[suf] !== n) { cur[suf] = n; box.style.setProperty('--d' + suf, n); }
        });
      }, { threshold: 0.1, rootMargin: '-20px 0px 0px 0px' });
      obs[suf].observe(btns[0]);
    }
    run(); window.addEventListener('resize', run, { passive: true });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#scroll-to-top"]');
    if (!a) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  function start() {
    // gp-icon-list is defined by section 1's (non-lazy) script, so on the live page EVERY gp-icon-list, including those in
    // still-lazy sections (their CSS still text/disabled-css), is constructed at page load: line-height is read then.
    document.querySelectorAll('gp-icon-list').forEach(iconList);
    document.querySelectorAll('gp-sticky').forEach(function (el) { whenLive(el, sticky); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
